<!-- 智能底座选择绑定的设备 -->
<template>
  <modal
    :visible.sync="visible"
    :title="$t('integration.device_selection')"
    width="800px"
    :appendToBody="true"
  >
    <div v-loading="loading">
      <!-- 搜索 -->
      <div class="uk-flex uk-flex-middle uk-flex-center">
        <span>{{ $t('integration.equipment_no') }}</span>
        <el-input
          v-model="model.code"
          class="input-width ml-5 mr-5"
          :placeholder="$t('integration.please_enter_the_device_number')"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </div>

      <!-- 列表 -->
      <div class="uk-margin-small-top" style="width: 90%;margin:0 auto">
        <div style="height:300px;overflow:auto">
          <!-- v-for -->
          <div
            v-for="(sensor, index) in sensorList"
            :key="sensor.id"
            class="uk-flex mb-5 uk-flex-middle border border-box "
            :class="{ 'active color-white': selected.id === sensor.id }"
            style="line-height: 30px;border-radius: 5px;"
          >
            <div
              class="bd-r uk-flex uk-flex-center bg-white"
              style="width: 30px;"
            >
              <el-checkbox
                v-model="checkbox[index]"
                @change="checkboxChange(index)"
              ></el-checkbox>
            </div>
            <!-- 传感器名称 -->
            <div class="bd-r pl-5 uk-flex-1">
              <i
                :class="sensorType[sensor.deviceType].icon"
                class="cursor-pointer"
                :title="$t(sensorType[sensor.deviceType].title)"
              ></i>
              <i v-icon="['equiStatusConvert', sensor.deviceStatus]"></i>
              {{ sensor.deviceCode }}
            </div>
            <!-- 关联监测点 -->
            <div class="bd-r uk-flex-1 pl-5">
              {{
                sensor.carrierName ||
                  $t('integration.unassociated_monitoring_points')
              }}
            </div>

            <!-- 关联底座 -->
            <div class="uk-flex-1 pl-5">
              {{ sensor.plinthCode || $t('integration.unassociated_base') }}
            </div>
          </div>
        </div>

        <div class="uk-flex uk-flex-right">
          <Pagination
            class="pagination"
            :total="pagination.total"
            :page.sync="pagination.iDisplayStart"
            :limit.sync="pagination.iDisplayLength"
            @pagination="getListFn"
          ></Pagination>
        </div>
        <!-- <div class="uk-flex uk-flex-right">
            <el-checkbox v-model="replace" :true-label="1" :false-label="0" :label="$t('integration.do_you_want_to_force_replacement')"></el-checkbox>
        </div> -->
      </div>
    </div>
    <template #footer>
      <el-button @click="visible = false">
        {{ $t('integration.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirm">
        {{ $t('integration.confirm') }}
      </el-button>
    </template>
    <Tips ref="tips"></Tips>
  </modal>
</template>

<script>
import { bindSensor, getBindableDeviceList } from '@/api/modules/base'
import Tips from './Tips.vue'
import { sensorType } from '@/utils/dict/sensor'

export default {
  props: ['show', 'sceneId', 'baseId', 'current', 'carrierName'],
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    sensorType: () => sensorType
  },
  components: {
    Tips
  },
  watch: {
    baseId () {
      if (this.baseId !== undefined) {
        this.model.code = ''
        this.selected = { id: this.current }
        this.getListFn()
      }
    }
  },
  data () {
    return {
      checkbox: [],
      pagination: {
        total: 0,
        iDisplayStart: 0,
        iDisplayLength: 10
      },
      model: {
        code: ''
      },
      way: '',
      sensorList: [],
      selected: { id: 0 },
      loading: false
    }
  },
  methods: {
    resetCheckbox () {
      this.checkbox = this.checkbox.map(() => false)
    },
    getListFn () {
      this.loading = true
      getBindableDeviceList({
        sceneId: this.sceneId,
        code: this.model.code,
        iDisplayStart: this.pagination.iDisplayStart,
        iDisplayLength: this.pagination.iDisplayLength
      }).then(res => {
        const { pageInfo, result } = res.result
        this.pagination.total = pageInfo.total
        this.sensorList = result
        this.checkbox = result.map(() => false)
        result.forEach((item, index) => {
          if (item.id === this.selected.id) {
            this.checkbox[index] = true
          }
        })
        this.loading = false
      })
    },
    async confirm () {
      if (this.current === this.selected.id) return (this.visible = false)

      // 底座关联监测点且选择的设备也关联了监测点
      if (this.carrierName) {
        const way = await this.$refs.tips.open({
          deviceCarrierName: this.selected.carrierName,
          baseCarrierName: this.carrierName,
          deviceProbeName: this.selected.carrierDeviceName
        })
        this.way = way
      } else if (this.selected.plinthId) {
        // 选择的设备已关联了底座
        await this.$confirm(
          $t(
            'integration.this_device_is_already_associated_with_a_base_dot__are_you_sure_you_want_to_forcibly_replace_it_q'
          )
        )
        this.way = 3
      }
      bindSensor(this.baseId, this.selected.id, this.way).then(res => {
        this.$message.success($t('integration.binding_successful'))
        this.$parent.$parent.getListFn()
        this.visible = false
        this.$emit('getList')
      })
    },
    search () {
      this.getListFn()
    },
    checkboxChange (index) {
      this.checkbox = this.checkbox.map(() => false)
      this.checkbox[index] = true
      this.selected = this.sensorList[index]
    }
  }
}
</script>
